export default __webpack_public_path__ + "static/media/giftPlate.c5dd75b1.png";